import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { authInterceptorProviders } from './../_helpers/auth.interceptor';
import { MathModule } from './../math/math.module';
import { SharedModule } from './../shared/shared.module';
import { AnswerPromptPresentationComponent } from './answer-prompt-presentation/answer-prompt-presentation.component';
import { ChangeQuizAreaComponent } from './change-quiz-area/change-quiz-area.component';
import { DoQuestionComponent } from './do-question/do-question.component';
import { DoQuizComponent } from './do-quiz/do-quiz.component';
import { ModifySubtopicComponent } from './modify-subtopic/modify-subtopic.component';
import { NewQuizComponent } from './new-quiz/new-quiz.component';
import { PerformanceSubtopicComponent } from './performance-subtopic/performance-subtopic.component';
import { ReviewQuizComponent } from './review-quiz/review-quiz.component';
import { ReviseQuestionAnswerDescriptionComponent } from './revise-question-answer-description/revise-question-answer-description.component';
import { ReviseQuestionComponent } from './revise-question/revise-question.component';
import { ReviseQuizComponent } from './revise-quiz/revise-quiz.component';
import { ShowQuestionComponent } from './show-question/show-question.component';
import { ShowQuizComponent } from './show-quiz/show-quiz.component';
import { WorksheetComponent } from './worksheets/worksheet/worksheet.component';


import { ProgressReportTabComponent } from './progress-report-tab/progress-report-tab.component';
import { QuizTabDoneComponent } from './quiz-tab-done/quiz-tab-done.component';
import { StarRatingComponent } from './star-rating/star-rating.component';

import { DoPromptComponent } from './do-prompt/do-prompt.component';
import { DoQuestionPromptComponent } from './do-question-prompt/do-question-prompt.component';
import { ImageAnswerConceptComponent } from './image-answer-concept/image-answer-concept.component';
import { ImageAnswerExplanationComponent } from './image-answer-explanation/image-answer-explanation.component';
import { ImageQuestionComponent } from './image-question/image-question.component';
import { LessonSyllabusComponent } from './lessons/lesson-syllabus/lesson-syllabus.component';
import { ShowConceptComponent } from './lessons/show-concept/show-concept.component';
import { SubtopicConceptComponent } from './lessons/subtopic-concept/subtopic-concept.component';
import { PendingQuizListComponent } from './pending-quiz-show/pending-quiz-list/pending-quiz-list.component';
import { PendingQuizShow } from './pending-quiz-show/pending-quiz-show.component';
import { ReviseAnswerPromptDescriptionComponent } from './revise-answer-prompt-description/revise-answer-prompt-description.component';
import { ReviseQuestionPromptComponent } from './revise-question-prompt/revise-question-prompt.component';
import { ShowQuestionPromptComponent } from './show-question-prompt/show-question-prompt.component';
import { SubtopicDetailComponent } from './subtopic-detail/subtopic-detail.component';
import { FreeSubTopicWorksheetComponent } from './worksheets/free-sub-topic-worksheet/free-sub-topic-worksheet.component';
import { WorksheetDownloadComponent } from './worksheets/worksheet-download/worksheet-download.component';
import { QuizFreePdfComponent } from './quiz-free-pdf/quiz-free-pdf.component';


@NgModule({
  declarations: [
    DoQuizComponent,
    DoQuestionComponent,
    ReviewQuizComponent,
    ShowQuizComponent,
    ReviseQuizComponent,
    ReviseQuestionComponent,
    ShowQuestionComponent,
    ReviseQuestionAnswerDescriptionComponent,
    ChangeQuizAreaComponent,
    NewQuizComponent,
    ProgressReportTabComponent,
    StarRatingComponent,
    PerformanceSubtopicComponent,
    ModifySubtopicComponent,

    PendingQuizShow,
    QuizTabDoneComponent,
    AnswerPromptPresentationComponent,
    DoQuestionPromptComponent,
    DoPromptComponent,
    LessonSyllabusComponent,
    SubtopicConceptComponent,
    ShowConceptComponent,
    ImageAnswerExplanationComponent,
    ImageQuestionComponent,
    ReviseQuestionPromptComponent,
    ShowQuestionPromptComponent,
    ImageAnswerConceptComponent,
    ReviseAnswerPromptDescriptionComponent,
    PendingQuizListComponent,
    SubtopicDetailComponent,
    WorksheetComponent,
    WorksheetDownloadComponent,
    FreeSubTopicWorksheetComponent,
    QuizFreePdfComponent
  ],
  imports: [
    CommonModule,
    MathModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    DataTablesModule
  ],
  exports:[
    QuizTabDoneComponent,
    PendingQuizShow,
    LessonSyllabusComponent,
    SubtopicConceptComponent,
    ModifySubtopicComponent,
    ReviseQuestionAnswerDescriptionComponent,
    ReviseQuestionPromptComponent,
    ReviseQuestionComponent,
    ImageAnswerConceptComponent,
    ImageAnswerExplanationComponent,
    DoPromptComponent,
    ShowQuestionComponent
  ],
  providers:[
    authInterceptorProviders
  ]
})
export class QuizModule { }
